// extracted by mini-css-extract-plugin
export default {"root":"DownloandPdf_root__yYwyq","loading":"DownloandPdf_loading__Fp-Ls","icon":"DownloandPdf_icon__qhdPp"};